const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Movie%20scene%20with%20dramatic%20lighting%20and%20cinematic%20composition%2C%20two%20characters%20in%20tense%20dialogue%20in%20modern%20urban%20setting%2C%20warm%20color%20grading%20with%20golden%20hour%20tones%2C%20film%20grain%20texture%2C%20professional%20cinematography%20style&width=800&height=450&seq=media-01&orientation=landscape',
    title: '久久视频 · 《光影之间》热播进行中',
    duration: '120分钟',
    tag: '热播中',
    alt: '久久视频热播光影之间',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Animated%20scene%20with%20vibrant%20colors%20and%20dynamic%20action%2C%20Japanese%20anime%20inspired%20art%20style%2C%20characters%20in%20futuristic%20cityscape%2C%20dramatic%20perspective%20angles%2C%20rich%20saturated%20colors%2C%20cinematic%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    title: '小蓝视频 · 《星海征途》独家上线',
    duration: '25集连播',
    tag: '独播',
    alt: '小蓝视频星海征途独播',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Documentary%20style%20scene%20with%20sweeping%20landscape%20vista%2C%20mountains%20and%20valleys%20in%20warm%20golden%20light%2C%20aerial%20perspective%2C%20natural%20wonder%20feeling%2C%20high%20detail%20nature%20photography%20with%20cinematic%20color%20grading&width=800&height=450&seq=media-03&orientation=landscape',
    title: '豆花视频 · 《大地脉动》纪录片精选',
    duration: '6集全',
    tag: '限免',
    alt: '豆花视频大地脉动纪录片',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩推荐</h2>
            <p className="text-sm md:text-base text-foreground-600">
              久久视频、小蓝视频、豆花视频热门内容精选推荐，总有一部适合你
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item, i) => (
              <div key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.alt}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-background-50/80 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                      <div className="w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-l-[18px] border-l-primary-500 ml-1"></div>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-1 bg-background-950/80 text-background-50 text-xs rounded">
                    {item.duration}
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded">{item.tag}</span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}